<template>
    <div class="role_management">
        <!--  角色管理  -->
        <div class="search_data">
            <div class="item_title">Status:</div>
            <div class="item_select">
                <el-select clearable v-model="selectValue" placeholder="All" @change="getRoleList">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="item_keyword">
                <el-input v-model="inputValue" placeholder="Please Enter Keywords"></el-input>
            </div>
            <div class="item_submit" @click="searchData">Search</div>

            <div class="add_new" @click="addNew">
                <span class="el-icon-circle-plus add_new_icon">&nbsp;Add New</span>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table">
            <TableTem
                    size="mini"
                    :isSelection="false"
                    :isIndex="true"
                    :isPagination="true"
                    :isHandle="true"
                    :tableData="tableData"
                    :tableCols="tableCols"
                    :pagination="pagination"
                    @select="select"
                    @passRowData="passRowData"
                    @switchVal1="switchVal1"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
            ></TableTem>
        </div>

        <!-- // 添加角色 || 编辑角色 -->
        <RoleDialog
                @visible="visible"
                :passVisible="roleVisible"
                :title="RoleTitle"
                :editMessage="editMessage"
                :selectValue="selectValue"
                :inputValue="inputValue"
                @submitForm="submitForm"
                :editId="editId"
        ></RoleDialog>
    </div>
</template>

<script>
    import TableTem from "./components/TableTem.vue";
    import qs from "qs";
    import {tableCols} from "@/conf/Role.js";
    import RoleDialog from "./components/RoleDialog.vue";
    import {
        roleList,
        deleteRole,
        roleDetail,
        roleMessage,
        roleState
    } from "@/common/js/http/version3Api.js";

    export default {
        name: "Role",
        components: {
            TableTem,
            RoleDialog
        },
        data() {
            return {
                roleVisible: false,
                RoleTitle: "",
                editMessage: [],
                editId: "",
                tableCols,
                roleId: "",
                tableData: [],
                pagination: {},
                options: [
                    {
                        value: "1",
                        label: "On"
                    },
                    {
                        value: "0",
                        label: "Off"
                    },
                    {
                        value: "",
                        label: "All"
                    }
                ],
                selectValue: "",
                inputValue: "",
                data: {},
                switchId: "",
                switchState: "",
                roleName: ""
            };
        },
        created() {
            this.getRoleList();
        },
        methods: {
            submitForm(ruleForm, permissionIds) {
                this.roleName = ruleForm.roleName;
                this.data = {
                    id: this.editId,
                    permissionIds: permissionIds,
                    roleDesc: ruleForm.roleDesc,
                    roleName: this.roleName,
                    status: ruleForm.status,
                    brandToken: localStorage.getItem('brand-token')
                };
                permissionIds = [];
                this.addRole();
            },
            //开关状态
            switchVal1(row) {
                this.switchId = row.id;
                this.switchState = row.status;

                this.updateRoleState();
            },
            //添加角色
            addRole() {
                roleMessage(JSON.stringify(this.data)).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                        this.getRoleList();
                    }
                });
            },
            select(row) {
            },
            visible(val, newsValue) {
                this.roleVisible = val;
                this.editId = "";
            },
            // 搜索数据
            searchData() {
                this.getRoleList();
            },
            deleteRow(index, rows) {
            },
            querySwitchVal(val) {
            },
            scopeData(rowData) {
            },
            // 添加 新角色
            addNew() {
                this.permissionIds = "";
                this.roleVisible = true;
                this.RoleTitle = "Creating Role";
            },
            // 获取 表格传递的数据
            async passRowData(rowData) {
                this.roleId = rowData.rowData.id;

                if (rowData.button == "delete") {
                    this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            deleteRole({roleId: this.roleId}).then(res => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: "success",
                                        message: "删除成功!"
                                    });
                                    this.getRoleList();
                                }
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除"
                            });
                        });
                    //this.delRole();
                } else {
                    this.editId = rowData.rowData.id;

                    this.getMessageRole();
                }

                let buttonType = rowData.button;
                switch (buttonType) {
                    case "edit":
                        // 添加关联品牌
                        this.roleVisible = true;
                        this.RoleTitle = "Edit Role";
                        break;
                }
            },
            handleCurrentChange(val) {
                this.pagination.pageNum = val;
                this.getRoleList();
            },
            handleSizeChange(val) {
                this.pagination.pageSize = val;
            },
            //获取角色列表
            getRoleList() {
                let data = {
                    roleName: this.inputValue,
                    status: this.selectValue,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize
                };
                roleList(data).then(res => {
                    this.tableData = res.result.list;
                    this.pagination.total = res.result.total;
                    this.pagination.pageSize = res.result.pageSize;
                    this.pagination.pageNum = res.result.pageNum;
                });
            },
            //删除角色
            async delRole() {
                let res = await deleteRole({roleId: this.roleId});

                this.getRoleList();
            },
            //查询详细信息
            getMessageRole() {
                roleDetail({roleId: this.roleId}).then(res => {
                    this.editMessage = res.result;
                });
            },
            //更新角色状态
            updateRoleState() {
                let data = {
                    roleId: this.switchId,
                    status: this.switchState * 1,
                    brandToken: localStorage.getItem('brand-token')
                };

                roleState(qs.stringify(data)).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                    }
                });
            }
        },
        watch: {
            editMessage: {
                handler(newValue) {
                },
                deep: true
            },
            switchId: {
                handler(newValue) {
                    this.switchId = newValue;
                },
                deep: true
            },
            switchState: {
                handler(val) {
                    this.switchState = val;
                },
                deep: true
            }
        }
    };
</script>

<style scoped>
    .search_data > div {
        display: inline-block;
        margin-right: 15px;
        vertical-align: middle;
    }

    .search_data >>> .el-input__inner,
    .search_data >>> .el-input__icon {
        height: 32px;
        line-height: 32px;
    }

    .search_data .item_submit {
        cursor: pointer;
        width: 74px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: #0078ff;
        border-radius: 2px;
        border: 1px solid #0078FF;
    }

    .role_management {
        padding: 10px;
    }

    .add_new {
        float: right;
    }

    .add_new span {
        cursor: pointer;
        user-select: none;
        width: 90px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: rgba(0, 0, 0, 0);
        border: 1px solid #0078ff;
        font-size: 14px;
        color: #0078ff;
        border-radius: 2px;
    }
</style>